const cookieNames = {
  locale: 'locale',
  giftData: 'giftData',
  userGender: 'userGender',
  activeFilters: 'activeFilters',
  sameAddresses: 'sameAddresses',
  shippingFields: 'shippingFields',
  facebookGender: 'facebookGender',
  facebookEmailRegistration: 'facebookEmailRegistration',
  isFacebookMixLandingCampaign: 'isFacebookMixLandingCampaign',
  pinchmePageEmail: 'pinchmePageEmail',
  referrerLandingPageURL: 'referrerLandingPageURL',
  paymentGiftSubscription: 'paymentGiftSubscription',
  paymentGiftCard: 'paymentGiftCard',
  payPalPaymentGiftSubscription: 'payPalPaymentGiftSubscription',
  payPalGiftCard: 'payPalGiftCard',
  unregisteredUserQuizData: 'unregisteredUserQuizData',
  giftCardCodeForClaiming: 'giftCardCodeForClaiming',
  extraHomeTopButtonClicked: 'extraHomeTopButtonClicked',
  giftCoupon: 'giftCoupon',
  offer: 'offer',
  discountCoupon: 'discountCoupon',
  reactivateSubscription: 'reactivateSubscription',
  smsThesisSplit: 'smsThesisSplit',
  facebookThesisSplit: 'facebookThesisSplit',
  facebookThesisSplitMen: 'facebookThesisSplitMen',
  makeupIntroFlow: 'makeupIntroFlow',
  skincareIntroFlow: 'skincareIntroFlow',
  firstVisitTimestamp: 'firstVisitTimestamp',
  isPayPalBannerVisible: 'isPayPalBannerVisible',
  isProfileInviteBlockVisible: 'isProfileInviteBlockVisible',
  selectedPlan: 'selectedPlan',
  lastTimeAddToQueue: 'lastTimeAddToQueue',
  priceWithDiscount: 'priceWithDiscount',
  timezone: 'timezone_offset',
  mainPageStories: 'mainPageStories',
  newPaymentCouponCode: 'newPaymentCouponCode',

  // session cookies
  specialFlowName: 'specialFlowName',
  isJustSubscribed: 'isJustSubscribed',
  isSessionExpired: 'isSessionExpired',
  isImproveSurveyBannerHidden: 'isImproveSurveyBannerHidden',
  isFragranceConceptsBannerHidden: 'isFragranceConceptsBannerHidden',
  isFacebookFlowEnabled: 'isFacebookFlowEnabled',
  collectionsClickPlacement: 'collectionsClickPlacement',
  isPutFirstInQueueModalShown: 'isPutFirstInQueueModalShown',
  buyQueuePageData: 'buyQueuePageData',
  features: 'test_features',
  abTests: 'test_abTests',
  pastPurchaser: 'pastPurchaser',
  banners: {
    recommendationsImprove: 'RecommendationsImproveBanner',
    appStoreBanner: 'appStoreBanner',
  },
  unpauseData: 'unpauseData',
  casesSubscription: 'casesSubscription',
  acquisitionQuizData: 'acquisitionQuizData',
  mobileMenuFirstClick: 'mobileMenuFirstClick',
  bindedCoupon: 'bindedCoupon',
  isSocialLogin: 'isSocialLogin',
  isShippingFormValid: 'isShippingFormValid',
  shippingFormInitialValues: 'shippingFormInitialValues',
  showInfoInPickPage: 'showInfoInPickPage',
  isFreeTrialOrgFlow: 'isFreeTrialOrgFlow',
  isPrepaidCardWithSubscriptionPlansModalHidden: 'isPrepaidCardWithSubscriptionPlansModalHidden',

  // Deprecated cookies use localStorageNames instead
  postponed: {
    queueProduct: 'postponedQueueProduct',
    queueProducts: 'postponedQueueProducts',
    queueLimitedProduct: 'postponedQueueLimitedProduct',
    queueLimitedProducts: 'postponedQueueLimitedProducts',
    cartProduct: 'postponedCartProduct',
    skincareIntoItems: 'skincareIntoItems',
    makeupLandingItems: 'makeupLandingItems',
    makeupLandingNewStyleItems: 'makeupLandingNewStyleItems',
    pickYourScentFlowItems: 'pickYourScentFlowItems',
    collectionLandingPageItems: 'customCollectionsPageItems',
    stockNotificationSubscriptionProductId: 'stockNotificationSubscriptionPostponedProductId',
  },
}


export default cookieNames
